"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreSanitizeOperation = exports.isPostSanitizeOperation = exports.TapeBuilderTaskNoTypeDefinitionSchemas = exports.TapeBuilderTaskSchema = void 0;
const zod_1 = require("zod");
const OperationNodes = __importStar(require("./operations/index"));
exports.TapeBuilderTaskSchema = zod_1.z.discriminatedUnion('operation', [
    OperationNodes.Asset2Json.TaskSchema,
    OperationNodes.AttachHeader.TaskSchema,
    OperationNodes.Edit.TaskSchema,
    OperationNodes.Filter.TaskSchema,
    OperationNodes.Flatten.TaskSchema,
    OperationNodes.Join.TaskSchema,
    OperationNodes.Pdf2Csv.TaskSchema,
    OperationNodes.PreFilter.TaskSchema,
    OperationNodes.Sanitize.TaskSchema,
    OperationNodes.Stack.TaskSchema,
    OperationNodes.Unzip.TaskSchema,
    // zod4 allows discriminated unions in discriminated unions!!
    OperationNodes.Ai2CsvTransform.TaskSchema,
    OperationNodes.PyXlsx2Csv2.TaskSchema,
    OperationNodes.Xlsx2Csv.TaskSchema,
    OperationNodes.Xlsx2Csv2.TaskSchema,
    OperationNodes.PyXlsxVirtualSheet2Csv.TaskSchema,
    OperationNodes.PyCsvVirtualSheet.TaskSchema,
]);
exports.TapeBuilderTaskNoTypeDefinitionSchemas = [
    OperationNodes.AttachHeader.TaskSchema,
    OperationNodes.Xlsx2Csv.TaskSchema,
    OperationNodes.Pdf2Csv.TaskSchema,
    OperationNodes.PreFilter.TaskSchema,
    OperationNodes.PyXlsx2Csv2.TaskSchema,
    OperationNodes.PyXlsxVirtualSheet2Csv.TaskSchema,
    OperationNodes.PyCsvVirtualSheet.TaskSchema,
    OperationNodes.Unzip.TaskSchema,
];
const NoTypeDefinitionOperations = [
    'attachHeader',
    'xlsx2csv',
    'pdf2csv',
    'preFilter',
    'pyXlsx2Csv2',
    'unzip',
];
// operations that produced sanitized tapes. TapeBuilderTaskWithTapeDefinition
const PostSanitizeOperations = [
    // 'asset2json', // this is a json task, should this be included here?
    'sanitize',
    'filter',
    'join',
    'edit',
    'xlsx2csv2',
    'pyXlsxVirtualSheet2Csv',
    'pyCsvVirtualSheet',
    'stack',
    'flatten',
];
const isPostSanitizeOperation = (operation) => {
    return PostSanitizeOperations.includes(operation);
};
exports.isPostSanitizeOperation = isPostSanitizeOperation;
const isPreSanitizeOperation = (operation) => {
    return NoTypeDefinitionOperations.includes(operation);
};
exports.isPreSanitizeOperation = isPreSanitizeOperation;
//# sourceMappingURL=tasks.js.map